import { Injectable, signal } from '@angular/core';

export interface LoginError {
  error: string;
  description: string | null;
}

/** Keycloak's `error_description` when the user declines the terms of use. */
export const TERMS_DECLINED_DESCRIPTION = 'termsAndConditionsDeclined';

/**
 * Remembers why Keycloak ended a login. angular-auth-oidc-client consumes the callback URL
 * and sends every failure to the same unauthorized route without saying why, so the
 * `error` / `error_description` query parameters must be read before `checkAuth()` runs.
 */
@Injectable({ providedIn: 'root' })
export class LoginErrorService {
  private readonly captured = signal<LoginError | null>(null);

  readonly loginError = this.captured.asReadonly();

  captureFrom(url: string): void {
    const params = new URL(url).searchParams;
    const error = params.get('error');
    if (error) {
      this.captured.set({ error, description: params.get('error_description') });
    }
  }
}
